import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// 应用挂在 PUBLIC_URL（package.json homepage）下，访问不带前缀的地址时补上前缀
const base = process.env.PUBLIC_URL
const { pathname, search, hash } = window.location
if (base && pathname !== base && !pathname.startsWith(base + '/')) {
  window.location.replace(base + (pathname === '/' ? '' : pathname) + search + hash)
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
